import { helpers } from '@vuelidate/validators';
import { CommonConstants } from '@/config/constant';

export const isNotEmpty = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return false;
  }
  return true;
};

export const onlyKanaOrNull = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return CommonConstants.KATAKANA_VALIDATION_REGEX.test(value);
};

export const isPhoneNumberOrNull = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return CommonConstants.PHONE_VALIDATION_REGEX.test(value);
};

export const isZipCodeOrNull = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return CommonConstants.ZIPCODE_VALIDATION_REGEX.test(value);
};

export const isAlphanumSpecialOrNull = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return CommonConstants.ALPHANUMSPECIAL_VALIDATION_REGEX.test(value);
};

export const isAlphanumSpecialWithMinMaxLength = (minLength, maxLength) =>
  helpers.withParams({ type: 'alphanumSpecialWithMinMaxLength', min: minLength, max: maxLength }, (value) => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return (
      CommonConstants.ALPHANUMSPECIAL_VALIDATION_REGEX.test(value) &&
      value.length >= minLength &&
      value.length <= maxLength
    );
  });

export const isAlphanumAndSpecialWithMinMaxLength = (minLength, maxLength) =>
  helpers.withParams({ type: 'alphanumAndSpecialWithMinMaxLength', min: minLength, max: maxLength }, (value) => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return (
      CommonConstants.ALPHANUM_AND_SPECIAL_VALIDATION_REGEX.test(value) &&
      value.length >= minLength &&
      value.length <= maxLength
    );
  });

export const isChecked = (value) => {
  return value;
};

export const checkMinLengthWithOnlyNumber = (minLength) =>
  helpers.withParams({ type: 'minLength', min: minLength }, (value) => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    const onlyNumberValue = value.replace(CommonConstants.NUMBER_VALIDATION_REGEX, '');
    return onlyNumberValue.length >= minLength;
  });

export const checkPasscodeIsSeqNumber = () => helpers.withParams({ noLabelFirst: true }, (value) => {
  if (typeof value === 'undefined' || value === null || value === '' || value.length < 6) {
    return true;
  }
  return !('0123456789'.includes(value));
});

export const checkPasscodeIsSameNumber = () => helpers.withParams({ noLabelFirst: true }, (value) => {
  if (typeof value === 'undefined' || value === null || value === '' || value.length < 6) {
    return true;
  }
  return CommonConstants.IS_SAME_DIGITS.test(value);
});

export const checkSameAs = (equalTo) =>
  helpers.withParams({ type: 'isRepeatedNewPasscode', noLabelFirst: true, eq: equalTo }, (value, parentVm) => {
  return value === parentVm[equalTo];
});

export const checkExpirationDate = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  } else {
    const currentYear = Number(
      new Date()
        .getFullYear()
        .toString()
        .slice(2, 4)
    );
    const currentMonth = new Date().getMonth() + 1;
    const month = value.split('/')[0];
    const year = value.split('/')[1];
    if (month > 12) return false;
    if (year == currentYear) return month >= currentMonth;
    else if (year > currentYear) return true;
    else return false;
  }
};

export const notSpace = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return !CommonConstants.SPACE_REGEX.test(value);
};
export const notFullSize = () => helpers.withParams({ noLabelFirst: true }, (value) => {
  const regex = new RegExp(CommonConstants.ONLY_APHABET_HALFSIZE);
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  const isContainHalfSize = regex.test(value);
  return !isContainHalfSize;
});

export const isSpecialPhoneNumber = (value) => {
  return CommonConstants.FORMAT_PHONE_VALIDATION_REGEX.test(value);
};

export const isNotEmptyMemo = (memo) =>
  helpers.withParams({ type: 'emptyMemo', memo: memo }, (value) => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return false;
    }
    return true;
  });

export const checkMaxLengthMemo = (memo, maxLength) =>
  helpers.withParams({ type: 'maxLength', memo: memo, max: maxLength }, (value) => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return value.length <= maxLength;
  });